import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

import * as AuthStateActions from './auth-state.actions';

@Injectable()
export class AuthStateEffects {
  constructor(private actions$: Actions) {}
}
